import React from "react";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/components/ui/hover-card";
import { BiSolidHelpCircle } from "react-icons/bi";

type HintLabelProps = {
  label: string; // Label text
  hint?: React.ReactNode; // Can be plain text or JSX/HTML
  className?: string; // Optional extra classes for label container
};

const HintLabel: React.FC<HintLabelProps> = ({ label, hint, className }) => {
  return (
    <div
      className={`flex gap-1 items-center whitespace-nowrap ${className || ""}`}
    >
      <span>{label}</span>
      {hint && (
        <HoverCard openDelay={100}>
          <HoverCardTrigger asChild className="inline-block cursor-pointer">
            <span>
              <BiSolidHelpCircle size={12} />
            </span>
          </HoverCardTrigger>
          <HoverCardContent className="whitespace-normal">
            {typeof hint === "string" ? <span>{hint}</span> : hint}
          </HoverCardContent>
        </HoverCard>
      )}
    </div>
  );
};

export default HintLabel;
